export const folderStatusHistoryFrag = `
    id
    status
    dateFrom
    dateTo
`;
